import listTemplate from './list/list.pug';
import formTemplate from './form/form.pug';
import viewTemplate from './view/view.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider
    .state('group.view.settings.memType', {
    // /context/:ctxId/groups/:groupId/memberTypes
    // :ctxId = ancestor/context group, :groupId = group
      url: '/membertypes',
      abstract: true,
      template: '<ui-view />'
    })
    .state('group.view.settings.memType.list', {
      url: '',
      template: listTemplate,
      controller: 'MemTypeListCtrl',
      controllerAs: 'mtvm',
      authenticate: true
    })
    .state('group.view.settings.memType.new', {
      url: '/new',
      template: formTemplate,
      controller: 'MemTypeFormCtrl',
      controllerAs: 'mtvm',
      authenticate: true
    })
    .state('group.view.settings.memType.view', {
      url: '/:mtId',
      template: viewTemplate,
      controller: 'MemTypeViewCtrl',
      controllerAs: 'mtvm',
      authenticate: true
    })
    .state('group.view.settings.memType.edit', {
      url: '/:mtId/edit',
      template: formTemplate,
      controller: 'MemTypeFormCtrl',
      controllerAs: 'mtvm',
      authenticate: true
    });
}];
